import React, { useState, useEffect, useRef } from "react";
import overviewBannerOne from "../../../assets/images/overviewBannerOne.jpg";
import overviewBannerTwo from "../../../assets/images/overviewBannerTwo.jpg";
import overerviewBannerThree from "../../../assets/images/overerviewBannerThree.jpg";
import overviewSection2Banner from "../../../assets/images/overviewSection2BannerNew.png";
import styles from "./Overview.module.scss";
// import AptechPartner from "../../../assets/images/AptechPartner.jpg";
import InfoCard from "../../CustomComponent/InfoCard.tsx";
// import goldenPeacockAward from "../../../assets/images/2024-golden-peacock-award.jpg";
// import preschoolAward from "../../../assets/images/2023-preschool.jpg";
// import franchisorAward from "../../../assets/images/2023-franchisor.jpg";
// import EducationAndSkill from "../../../assets/images/2023-Education-and-skill.jpg";
// import franchisor_Frow_Award from "../../../assets/images/franchisor-Frow-Award.jpg";
// import multimediaAward from "../../../assets/images/2023-multimedia.jpg";
// import goldenPeacock2023 from "../../../assets/images/goldenPeacock2023.jpg";
// import lakmeAcademy2023 from "../../../assets/images/lakmeAcademy2023.jpg";
// import EtBestBrandAward2022 from "../../../assets/images/EtBestBrandAward2022.jpg";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";
import { Icon } from "../../../assets/Icons.tsx";
// import Slider from "react-slick";
import successfulBannerImg from "../../../assets/images/successfulBannerImg.png";
import { motion } from "framer-motion";

interface DataItem {
  title: string;
  description: React.ReactNode;
  showHeading: boolean;
}
const infoCardsData = [
  "Present in 200+ cities worldwide",
  "740+ training centres globally",
  "Over 7.5 million students trained worldwide",
];
const data: DataItem[] = [
  {
    showHeading: true,
    title: "Domestic Retail",
    description: (
      <div>
        Aptech offers vocational programs under its multiple brands, including{" "}
        <strong>
          Arena Animation, Maya Academy of Advanced Creativity, Lakmē Academy
          Powered by Aptech, Aptech Learning, Avalon Academy, The Virtual
          Production Academy
        </strong>{" "}
        and <strong>ProAlley</strong>. 
      </div>
    ),
  },
  {
    showHeading: false,
    title: "Institutional Business (EBG)",
    description: (
      <div>
        EBG provides specialized training and assessment solutions for
        institutions and corporates through{" "}
        <strong>
          Aptech Training Solutions , Aptech Assessment & Testing Solutions
        </strong>{" "}
        and <strong>Education Institutes and Corporates (EIC) Unit</strong>. 
      </div>
    ),
  },
  {
    showHeading: false,
    title: "International Retail",
    description: (
      <div>
        Aptech is a leader in vocational and career-oriented training, with{" "}
        learning centres in various countries including Vietnam, Egypt, Qatar,
        Kenya, Malaysia, UAE, Saudi Arabia, and Nigeria. It has partnered with
        various <strong>universities and educational institutions</strong>{" "}
        abroad to make international education accessible to students.
      </div>
    ),
  },
];
// type CarouselItem = {
//   id: number;
//   imgSrc: string;
//   text: string;
// };

// const carouselData: CarouselItem[] = [
//   {
//     id: 1,
//     imgSrc: goldenPeacockAward,
//     text: "Golden Peacock National Training Award 2024 at the 2024 UAE Global Convention & 31st Annual World Congress on Leadership for Innovation & Business Excellence.",
//   },
//   {
//     id: 2,
//     imgSrc: preschoolAward,
//     text: "Aptech International Pre-School has won a jury’s choice award as ‘Pre-school with Best Curriculum’ at the 5th edition of Scoonews Global Educators Fest 2023.",
//   },
//   {
//     id: 3,
//     imgSrc: franchisorAward,
//     text: `Aptech has won ‘Franchisor of the Year-Vocational Skilling and Training’ award in The Franchise Awards 2023.`,
//   },
//   {
//     id: 4,
//     imgSrc: EducationAndSkill,
//     text: "Aptech recognized as Leading I.T. Education and Skill Development Brand at the 25th World Education Summit ",
//   },
//   {
//     id: 5,
//     imgSrc: franchisor_Frow_Award,
//     text: "Aptech recognized as the Best Franchisor of the year for Education at FRO (Franchise & Retail Awards 2021, 2022 and 2023",
//   },
//   {
//     id: 6,
//     imgSrc: multimediaAward,
//     text: `Arena Multimedia recognized as "Leading Multimedia and Animation Training Brand" at the 25th World Education Summit`,
//   },
//   {
//     id: 7,
//     imgSrc: goldenPeacock2023,
//     text: " Golden Peacock National Training Award’’ at the Dubai Global Convention in the year 2023.",
//   },
//   {
//     id: 8,
//     imgSrc: lakmeAcademy2023,
//     text: `Lakmē Academy powered by Aptech has won gold & silver for its campaign at the ACEF Asian Leaders Forum, 2021, 2022 and 2023`,
//   },
//   {
//     id: 9,
//     imgSrc: EtBestBrandAward2022,
//     text: `Aptech Limited has been honoured as one of the ET Best Brands 2022 at the 5th Edition of 'Economic Times Best Brand Conclave’, 2022`,
//   },
// ];
// const chunkArray = <T,>(array: T[], size: number): T[][] => {
//   const chunks: T[][] = [];
//   for (let i = 0; i < array.length; i += size) {
//     chunks.push(array.slice(i, i + size));
//   }
//   return chunks;
// };

const OverviewSection: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about-us" },
    { title: "Overview", link: "" },
  ];

  // Sections list with refs
  const sections = [
    { component: <Banner />, ref: useRef(null) },
    { component: <BannerTwo />, ref: useRef(null) },
    { component: <PartnerSection />, ref: useRef(null) },
    { component: <OurValues />, ref: useRef(null) },
    { component: <SuccessfulCareer />, ref: useRef(null) },
    { component: <BusinessSection />, ref: useRef(null) },
  ];

  const [visibleSections, setVisibleSections] = useState<
    Record<number, boolean>
  >({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [parseInt(entry.target.dataset.section || "0")]: true,
            }));
          }
        });
      },
      { threshold: 0.2 },
    );

    sections.forEach(({ ref }, index) => {
      if (ref.current) {
        ref.current.dataset.section = index.toString();
        observer.observe(ref.current);
      }
    });

    return () => {
      sections.forEach(({ ref }) => {
        if (ref.current) observer.unobserve(ref.current);
      });
      observer.disconnect();
    };
  }, []);

  return (
    <div id="overViewSection" className={`${styles.overViewSection} mb-5`}>
      {/* Breadcrumb (No Animation) */}
      <BreadCrumb menu={breadcrumb} />

      {/* Animated Sections */}
      {sections.map(({ component, ref }, index) => (
        <motion.div
          key={index}
          ref={ref}
          initial={{ opacity: 0, y: 100 }}
          animate={visibleSections[index] ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeInOut" }}
          className={index === 4 ? "container-fluid" : "container"} // Ensure correct container type
        >
          {component}
        </motion.div>
      ))}
    </div>
  );
};

const Banner = () => {
  return (
    <div className="row g-0">
      <div className="col-lg-6 col-md-12 col-sm-12">
        <div className="mt-5">
          <p className="heading">About Aptech</p>
          <p className={"para"}>
            Established in <strong>1986</strong>, Aptech is a pioneer in{" "}
            <strong>vocational</strong> training and
            <strong> global</strong> learning solutions. With over three decades
            of experience, we have expanded our footprint from Mumbai, India to
            across <strong>20+ countries</strong>, offering diverse programs in
            sectors such as IT, Media and Entertainment, Aviation, Hospitality,
            Luxury Retail, Beauty and Wellness, Banking and Finance, and
            Preschool Education.
          </p>

          <div className="row g-2">
            {infoCardsData.map((text, index) => (
              <div
                className="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center"
                key={index}
              >
                <InfoCard text={text} height="100%" bgColor="#EDE6DA" />
              </div>
            ))}
          </div>
          <p className={"para pt-4"}>
            <a href="/" className={styles.linking}>
              Aptech{" "}
            </a>{" "}
            has successfully trained students for
            <a
              href="/our-businesses/domestic-retail"
              className={styles.linking}
            >
              {" "}
              vocational training{" "}
            </a>
            programs across diverse fields, including
            <ul className={styles.trainingDiv}>
              <li>Media and Entertainment</li>
              <li>Beauty and Wellness</li>
              <li>Aviation and Hospitality</li>
              <li>Information Technology </li>
              <li>Banking </li>
            </ul>
          </p>
        </div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12">
        <div className="row g-4 mt-1">
          <div className="col-6"></div>

          <div className="col-6 d-flex justify-content-start align-items-start">
            <img
              src={overviewBannerOne}
              alt="overviewBannerOne"
              className={"img-fluid"}
            />
          </div>
          <div className="col-6 d-flex justify-content-end align-items-end">
            <img
              src={overviewBannerTwo}
              alt="overviewBannerTwo"
              className={"img-fluid"}
            />
          </div>
          <div className="col-6 d-flex justify-content-start align-items-start">
            <img
              src={overerviewBannerThree}
              alt="overviewBannerThree"
              className={"img-fluid"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const BannerTwo = () => {
  return (
    <div className="section">
      <div className={`row g-5 mt-3 ${styles.BannetTwo}`}>
        <div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
          <img
            src={"/images/professional-business-team-portrait.png"}
            alt="Group Of Confident Business Professionals Standing Together"
            title="Professional Business Team Portrait"
            className={`img-fluid w-100 h-100 ${styles.overviewSection2Banner}`}
          />
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
          <div className={styles.OverviewSectionTwoContent}>
            <p className={"para"}>
              It is also committed to early childhood education, playing a vital
              role in the development of children and preschoolers.
            </p>
            <p className={"para"}>
              We also develop custom content for corporate training programs
              worldwide. At Aptech, we are committed to empowering individuals
              and organizations through quality education and corporate
              training, fostering skill development, and enhancing employability
              across various industries.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const BusinessSection = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div className="mb-2">
            <h6 className="heading">Businesses</h6>
            <p className="para pb-3">
              Aptech has successfully trained students, professionals,
              universities and private and government organizations through its
              three major streams of businesses – Domestic Retail, Institutional
              Business (EBG), and International Retail.
            </p>
          </div>
        </div>
      </div>

      <div className="row g-3 align-items-stretch">
        {data.map((item, index) => (
          <div key={index} className="col-lg-6 col-md-6 col-sm-12 mb-2 d-flex">
            <div className={styles.businessesSectionDiv}>
              <div className="row mb-2">
                <div className="col-12">
                  <h6
                    className={`cardHeading text-uppercase ${styles.businessSectionHeading}`}
                  >
                    <strong>{item.title}</strong>
                  </h6>
                </div>
              </div>
              <div className="row mt-3">
                <p className="para2">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
// const AwardSection = () => {
//   const [slides, setSlides] = useState([]);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   const sliderRef = useRef<Slider>(null); // Slider reference
//   const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
//   const isSmallScreen = screenWidth < 1025; // Small screens

//   useEffect(() => {
//     const chunkSlides = () => {
//       const isLargeScreen = screenWidth >= 992; // Large screens
//       const isSmallScreen = screenWidth < 768; // Small screens
//       return chunkArray(
//         carouselData,
//         isLargeScreen ? 3 : isSmallScreen ? 1 : 2
//       );
//     };

//     setSlides(chunkSlides()); // Update slides
//   }, [screenWidth]);

//   useEffect(() => {
//     const handleResize = () => {
//       setScreenWidth(window.innerWidth);
//     };

//     // Add resize event listener
//     window.addEventListener("resize", handleResize);

//     // Cleanup the event listener on unmount
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const settings = {
//     afterChange: (current) => {
//       setCurrentSlideIndex(current); // Update the current slide index
//     },
//     infinite: false, // Disable infinite loop
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     dots: false,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//     ],
//   };

//   const handleNext = () => {
//     if (sliderRef.current) {
//       sliderRef.current.slickNext(); // Move to next slide
//     }
//   };

//   const handlePrev = () => {
//     if (sliderRef.current) {
//       sliderRef.current.slickPrev(); // Move to previous slide
//     }
//   };
//   const isLastSlide = currentSlideIndex === slides.length - 1;
//   const isFirstSlide = currentSlideIndex === 0;

//   return (
//     <div className="section">
//       <div className={styles.AwardSection}>
//         <div className="row">
//           <div className="col-12">
//             <h6 className={"heading"}>Awards and Achievements</h6>
//             <div className="row">
//               <div className="col-lg-6 col-md-12 col-sm-12">
//                 <p className="para">
//                   Aptech has been a pioneer in the vocational and skill
//                   development sector, earning recognition and accolades for its
//                   innovative vocational training programs and commitment to
//                   excellence. The company’s consistent achievements across
//                   various sectors demonstrate our ability to deliver
//                   industry-relevant education and foster career growth.
//                 </p>
//               </div>
//               <div className="col-lg-6 col-md-12 col-sm-12">
//                 <p className="para">
//                   Aptech’s achievements highlight its dedication to bridging
//                   learning gaps, shaping careers, and creating employment
//                   opportunities for the youth in India and overseas.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-12">
//             <div className={styles.awardsCarousel}>
//               <div id="carouselExampleCaptions" className="carousel slide">
//                 <div
//                   className={`${styles.carouselInner} ${styles.carourselInnerBox}`}
//                 >
//                   <Slider
//                     ref={sliderRef}
//                     {...settings}
//                     className="overflow-hidden"
//                   >
//                     {slides.map((slide, index) => (
//                       <div
//                         key={index}
//                         className={`carousel-item ${
//                           index === 0 ? "active" : ""
//                         }`}
//                       >
//                         <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-sm-12 g-5">
//                           {slide.map((item) => (
//                             <div
//                               key={item.id}
//                               className="col-lg-4 col-md-6 col-sm-12"
//                             >
//                               <div className={styles.caourselData}>
//                                 <img
//                                   src={item.imgSrc}
//                                   alt={`item-${item.id}`}
//                                   className={styles.caourselImage}
//                                 />
//                                 <p className={"para pt-3"}>{item.text}</p>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     ))}
//                   </Slider>
//                 </div>

//                 <div
//                   className={`${styles.buttonGroup} control-btn translate-middle-y d-flex justify-content-end`}
//                 >
//                   {!isFirstSlide ? (
//                     <span
//                       className={styles.arrowButtonPrev}
//                       onClick={handlePrev}
//                     >
//                       <Icon
//                         name="backArrowIcon"
//                         width={`${isSmallScreen ? "50px" : "60px"}`}
//                         height={`${isSmallScreen ? "50px" : "60px"}`}
//                       />
//                     </span>
//                   ) : (
//                     <span className={styles.arrowButtonPrev}>
//                       <Icon
//                         name="backArrowIcon"
//                         width={`${isSmallScreen ? "50px" : "60px"}`}
//                         height={`${isSmallScreen ? "50px" : "60px"}`}
//                         color="#999999"
//                       />
//                     </span>
//                   )}

//                   {!isLastSlide ? (
//                     <span
//                       className={styles.arrowButtonNext}
//                       onClick={handleNext}
//                     >
//                       <Icon
//                         name="forwardArrowIcon"
//                         width={`${isSmallScreen ? "50px" : "60px"}`}
//                         height={`${isSmallScreen ? "50px" : "60px"}`}
//                       />
//                     </span>
//                   ) : (
//                     <span className={styles.arrowButtonNext}>
//                       <Icon
//                         name="forwardArrowIcon"
//                         width={`${isSmallScreen ? "50px" : "60px"}`}
//                         height={`${isSmallScreen ? "50px" : "60px"}`}
//                         color="#999999"
//                       />
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// const PartnerSection = () => {
//   return (
//     <div className="section">
//       <div className={`row ${styles.partnerSection}`}>
//         <div className="col-12">
//           <div className={`row ${styles.IndustrialSectionDiv}`}>
//             <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-center position-relative">
//               <div className={styles.innerDiv}>
//                 <p className="heading">Our Purpose</p>
//                 <p className="para">
//                   Whether you are looking to expand your business in the
//                   education sector or collaborate on specialized vocational
//                   training programs, Aptech offers a profitable business model
//                   in the education sector.
//                 </p>
//                 <ol className="mt-4 para">
//                   <li className="pb-0">
//                     <p className={"para mb-0"}>
//                       A proven and successful business model with 38+ years of
//                       experience
//                     </p>
//                   </li>
//                   <li className="pb-0">
//                     <p className={"para mb-0"}>
//                       Operates in 200+ cities globally, offering business
//                       partners access to diverse markets
//                     </p>
//                   </li>
//                   <li className="pb-0">
//                     <p className={"para mb-0"}>
//                       Career-oriented programs spanning across industries like
//                       animation, VFX, IT, wellness, beauty, and hospitality
//                     </p>
//                   </li>
//                   <li className="pb-0">
//                     <p className={"para mb-0"}>
//                       Empowers business partners to build a profitable business
//                       with holistic and ongoing support.{" "}
//                     </p>
//                   </li>
//                 </ol>
//               </div>

//               <div className={styles.borderSection} />
//             </div>
//             <div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-end align-items-end">
//               <img
//                 src={AptechPartner}
//                 alt="IndustrialImage"
//                 className={`img-fluid ${styles.IndustrialImage}`}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

const PartnerSection = () => {
  return (
    <div className="section">
      {/* <div className={`row ${styles.partnerSection}`}>
        <div className="col-12">
          <div className={styles.borderSection}>
            <div className={`row ${styles.IndustrialSectionDiv}`}>
              <div className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center">
                <div className={styles.innerDiv}>
                  <p className="heading">Our Purpose</p>
                  <p className="para">
                    To be a trusted, self-reliant, and widely recognized Indian
                    brand with a global presence, delivering vocational training
                    and career-oriented education to students, professionals,
                    universities, and corporate training to organisations. We
                    aim to create an ecosystem where the youth are skilled,
                    trained, and employed or self-employed.
                  </p>
                </div>
              </div>
              <div
                className={`col-lg-6 col-md-12 col-sm-12 col-12 ${styles.innerDivWrapper}`}
              >
                <div className={`${styles.innerDiv} pt-0`}>
                  <img
                    src={AptechPartner}
                    alt="IndustrialImage"
                    className={`img-fluid ${styles.IndustrialImage}`}
                  />
                </div>
              </div>
            </div>
            <div className={`row ${styles.IndustrialSectionDiv} mt-0`}>
              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                <div className={styles.innerDiv}>
                  <p className="heading">Mission</p>
                  <p className="para mb-0">
                    A trusted, self-reliant and widely recognized Indian brand,
                    with global footprint delivering vocational training,
                    skilling, and non-formal education to students,
                    professionals, universities, and corporates. It aims to
                    create and foster an ecosystem where youth are skilled,
                    trained, and prepared for successful employment or
                    entrepreneurship.
                  </p>
                </div>
              </div>
              <div
                className={`col-lg-6 col-md-12 col-sm-12 d-flex justify-content-start align-items-end`}
              >
                <div className={styles.innerDiv}>
                  <p className="heading">Vision</p>
                  <p className="para">
                    To be the preferred learning solutions company offering
                    vocational training, skilling and non-formal education, and
                    make our students highly employable and job-ready with our
                    industry relevant course curriculum.{" "}
                  </p>
                </div>
              </div>
            </div>

            <div></div>
          </div>
        </div>
      </div> */}
      <div className="row g-3 d-flex justify-content-center">
        <div className="col-lg-4 col-md-12 col-sm-12 text-center">
          <div className={styles.partnerCard}>
            <Icon name="ourPurpose" />
            <p
              className={`subHeading caps text-center ${styles.partnerCardTitle}`}
            >
              Our Purpose
            </p>
            <p className="para2 text-center">
              To be a trusted, self-reliant, and widely recognised Indian brand
              with a global presence, delivering vocational training and
              career-oriented education to students, professionals,
              universities, and corporate training to organisations. We aim to
              create an ecosystem where the youth are skilled, trained, and
              employed or self-employed.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-12 col-sm-12 text-center">
          <div className={styles.partnerCard}>
            <Icon name="mission" />

            <p
              className={`subHeading caps text-center ${styles.partnerCardTitle}`}
            >
              Mission
            </p>
            <p className="para2 text-center">
              A trusted, self-reliant and widely recognized Indian brand, with
              global footprint delivering vocational training, skilling, and
              non-formal education to students, professionals, universities, and
              corporates. It aims to create and foster an ecosystem where youth
              are skilled, trained, and prepared for successful employment or
              entrepreneurship.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-12 col-sm-12 text-center">
          <div className={styles.partnerCard}>
            <Icon name="vision" />
            <p
              className={`subHeading caps text-center ${styles.partnerCardTitle}`}
            >
              VISION
            </p>
            <p className="para2 text-center">
              To be the preferred learning solutions company offering vocational
              training, skilling and non-formal education, and make our students
              highly employable and job-ready with our industry relevant course
              curriculum.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const OurValues = () => {
  interface DataItemWorkForce {
    src: string;
    text: string;
    bold: string;
  }
  const workforce: DataItemWorkForce[] = [
    {
      src: "excellence",
      text: "We strive to provide the highest standards of learning and training delivery across all our programs, while adhering to industry trends and demands.",
      bold: "Excellence",
    },
    {
      src: "innovation",
      text: "We embrace new technologies and methodologies in our programs and training to enhance learning experiences, keeping pace with the evolving educational landscape.",
      bold: "Innovation",
    },
    {
      src: "incusive",
      text: "We believe that education should be accessible to diverse populations, thereby fostering an inclusive learning environment.",
      bold: "Inclusivity",
    },
    {
      src: "empower",
      text: "We are committed to empowering students, professionals, and corporates with the skills and knowledge necessary to achieve their career aspirations and succeed in their workplaces. ",
      bold: "Empowerment",
    },
  ];
  return (
    <div className="section">
      <div className="row">
        <p className="heading">Our Values</p>
        {workforce.map((workitem, index) => (
          <div
            className={`col-lg-3 col-md-12 col-sm-12 cik-12 pt-3`}
            key={index}
          >
            <Icon width="80px" height="80px" name={workitem.src} />

            <p className={`para ${styles.aimTextStyle}`}>
              {" "}
              <strong>{workitem.bold}</strong>: {workitem.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const SuccessfulCareer = () => {
  return (
    <div className="container-fluid">
      <div className="section">
        <div className={`row ${styles.successBannerSection} g-0`}>
          <div className="col-lg-3 col-md-12 col-sm-12 col-12">
            <div className={`${styles.successfulBannerImg}`}>
              <img
                src={"/images/student-attending-class.jpg"}
                alt="Focused Student Writing Notes"
                title="Student Writing During Lecture"
                className={`img-fluid`}
              />
            </div>
          </div>
          <div
            className={`col-lg-9 col-md-12 col-sm-12 col-12 ${styles.backgroundSuccessBanner} d-flex justify-content-end align-items-center`}
          >
            <div>
              <p className="para">
                With industry-focused training, Aptech prepares students for
                successful careers. We also provide them with the right skills
                and technical expertise to launch and start a new business in
                fields spanning across media, aviation, hospitality, IT, and
                beauty and wellness. In addition to our vocational courses, we
                also provide
                <a href="/our-businesses/institutional-business">
                  {" "}
                  comprehensive corporate training{" "}
                </a>{" "}
                to meet the changing demands of organizations, ensuring that
                both individuals and businesses achieve excellence in their
                fields.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewSection;
